export function setExpanded(data) {
  return {
    type: 'SET_EXPANDED',
    payload: data,
  }
}
